const role = Object.freeze({
  DataAdmin: "Data Admin",
  SuperAdmin: "Super Admin",
});

export default role;